import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { BottomNav } from "@/components/BottomNav";
import { AuthDialog } from "@/components/AuthDialog";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export function Layout() {
  return (
    <div className="App min-h-screen bg-slate-50">
      <ScrollToTop />
      <div className="mx-auto max-w-lg md:max-w-2xl bg-slate-50 min-h-screen relative shadow-sm">
        <Header />
        <main className="pb-28">
          <Outlet />
        </main>
        <BottomNav />
      </div>
      <AuthDialog />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default Layout;
